import React from 'react';
import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-20 bg-white" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-green-900 mb-4" data-id="element-52">
            Contact Us
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-53">
            Have questions? We'd love to hear from you. Reach out to us directly
            or visit us at the farm.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-54">
          <div className="flex flex-col items-center text-center p-6 bg-stone-50 rounded-xl hover:bg-green-50 transition-colors" data-id="element-55">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4 text-green-600" data-id="element-56">
              <Phone className="h-6 w-6" data-id="element-57" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-58">Call Us</h3>
            <p className="text-gray-600" data-id="element-59">+254 720 934332</p>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-stone-50 rounded-xl hover:bg-green-50 transition-colors" data-id="element-60">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4 text-green-600" data-id="element-61">
              <MessageCircle className="h-6 w-6" data-id="element-62" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-63">WhatsApp</h3>
            <a href="https://wa.me/254720934332" target="_blank" rel="noopener noreferrer" className="text-green-600 font-medium hover:underline" data-id="element-64">
              Chat on WhatsApp
            </a>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-stone-50 rounded-xl hover:bg-green-50 transition-colors" data-id="element-65">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4 text-green-600" data-id="element-66">
              <Mail className="h-6 w-6" data-id="element-67" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-68">Email Us</h3>
            <p className="text-gray-600" data-id="element-69">info@greenslopesfarm.co.ke</p>
          </div>

          <div className="flex flex-col items-center text-center p-6 bg-stone-50 rounded-xl hover:bg-green-50 transition-colors" data-id="element-70">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4 text-green-600" data-id="element-71">
              <MapPin className="h-6 w-6" data-id="element-72" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-73">Visit Us</h3>
            <p className="text-gray-600" data-id="element-74">Nyandarua County, Kenya</p>
          </div>
        </div>
      </div>
    </section>;
}